import React from 'react';
import { NavLink } from 'fluxible-router';
import Order from '../../models/Order';
import Store from '../../models/Store';
import shallowCompare from '../../lib/shallowCompare';
import ShoppingCartItem from '../ShoppingCartItem';
import OrderItemTile, { PhotoPositions } from '../OrderItemTile';
import styles from './index.sass';

class OrderSummaryTile extends React.Component {
  static propTypes = {
    order: React.PropTypes.instanceOf(Order),
    store: React.PropTypes.instanceOf(Store)
  };

  static contextTypes = {
    getUserAgent: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderItems(items, storeId) {
    let isMobile = this.context.getUserAgent().isMobile;
    return items.map(orderItem => {
      let props = {
        orderItem: orderItem,
        key: orderItem.id,
        storeId: storeId,
        showBuyAgainButton: true,
        showTotal: false,
        photoPosition: isMobile ? PhotoPositions.Right : PhotoPositions.Left
      };
      return <OrderItemTile {...props} />;
    });
  }

  render() {
    let { order, store } = this.props;
    let { isMobile } = this.context.getUserAgent();
    let receiptLink = <NavLink className={styles.receiptLink} routeName="order" navParams={{id: order.id}}>View receipt</NavLink>;

    return (
      <div className={styles.orderSummaryTile}>
        <div className={styles.upperSection}>
          <div className={styles.detailsBlock}>
            <p className={styles.storeName}>{order.store.name}</p>
            <p className={styles.orderDetails}>{isMobile ? '' : 'Order: #'}{order.order_number} • {order.formatted_submitted_at}</p>
            <p className={`${styles.orderState} ${styles[order.order_state]}`}>{order.order_state_text}</p>
          </div>
          <div className={styles.totalBlock}>
            <p className={styles.total}>{order.total_text}</p>
            {isMobile ? null : receiptLink}
          </div>
        </div>
        <div className={styles.lowerSection}>
          {this.renderItems(order.items, order.store.id)}
        </div>
        {isMobile ? <div className={styles.receiptLinkWrapper}>{receiptLink}</div> : null}
      </div>
    );
  }
}

export default OrderSummaryTile;



// WEBPACK FOOTER //
// banquet/components/OrderSummaryTile/index.js